import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrelloLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 630 630",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient",
			x1: 0,
			y1: 315,
			x2: 630,
			y2: 315,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#0052cc"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684ff"
			})]
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			width: 630,
			height: 630,
			style: { fill: "url(#linear-gradient)" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m440.1,151.06h-250.14c-21.52,0-38.97,17.43-39,38.95v249.78c-.04,10.37,4.05,20.33,11.37,27.68,7.32,7.35,17.26,11.48,27.63,11.48h250.14c10.36-.01,20.29-4.15,27.6-11.5,7.31-7.35,11.39-17.3,11.35-27.66v-249.78c-.03-21.5-17.45-38.92-38.95-38.95Zm-147.65,236.16c-.01,3.47-1.41,6.78-3.87,9.22-2.47,2.44-5.8,3.79-9.27,3.76h-54.66c-7.15-.03-12.93-5.83-12.93-12.98v-162.68c0-7.15,5.78-12.95,12.93-12.98h54.66c7.16.03,12.95,5.82,12.98,12.98l.16,162.68Zm126.15-74.69c0,3.47-1.39,6.8-3.86,9.24-2.47,2.44-5.81,3.79-9.28,3.75h-54.66c-7.16-.03-12.95-5.83-12.98-12.98v-87.99c.03-7.16,5.82-12.95,12.98-12.98h54.66c7.15.03,12.93,5.83,12.93,12.98l.21,87.99Z",
			style: {
				fill: "#fff",
				fillRule: "evenodd"
			}
		})
	]
});
export { SvgTrelloLogo as ReactComponent };
